// Path: ./src/app/pages/CreateDealTab/StyledComponents.tsx
import styled from "styled-components";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";

interface DateButtonProps {
  isSelected?: boolean;
}

export const InputFieldWrapper = styled.div`
  width: 100%;
  @media (max-width: 590px) {
    margin-bottom: 15px;
  }
`;
export const InputFieldLabel = styled.div`
  font-size: 16px;
  padding-bottom: 7px;
`;

export const LeftSideWrapper = styled.div`
  padding-left: 20px;
  padding-right: 40px;
  margin: 0 auto;
  max-width: 800px;
`;

export const PriceFieldsWrapper = styled.div``;

export const ProductNameCategorySection = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
`;
export const SecondLanguageSection = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  flex-direction: column;
`;

export const MuiAutoCompleteWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const PriceUnitSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 10px;
  @media (max-width: 590px) {
    flex-direction: column;
    align-items: start;
    justify-content: start;
  }
`;

export const DateSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  margin-top: 30px;
  max-width: 712px;
  @media (max-width: 590px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const DateButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  @media (max-width: 631px) {
    justify-content: center;
  }
`;

export const DateButton = styled.button<DateButtonProps>`
  width: 154px;
  height: 44px;
  background: ${({ isSelected }) =>
    isSelected
      ? "#f58220  0% 0% no-repeat padding-box"
      : "#ffffff 0% 0% no-repeat padding-box"};
  border: 3px solid #f58220;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;

  font-weight: 600;

  color: ${({ isSelected }) => (isSelected ? "white" : "#00000092")};
  &:hover {
    background: #f58220 0% 0% no-repeat padding-box;
    color: white;
  }
`;

export const RightSideWrapper = styled.div`
  padding-right: 40px;
  padding-left: 20px;
  margin: 0 auto;
  max-width: 800px;
`;

export const RightTopTitle = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
`;

export const UploadImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 590px) {
    flex-direction: column;
  }
`;
export const ImageSection = styled.div``;
export const UploadSection = styled.div`
  position: "relative";
  height: 100%;
`;

export const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 15px;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 20px;
  row-gap: 15px;
`;

export const Button = styled.button`
  font-size: 24px;
  font-weight: 500;
  padding: 20px;
  padding-top: 6px;
  padding-bottom: 6px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
  border-radius: 10px;
  border: 3px solid #ff813a;
  background-color: white;

  &:hover {
    font-size: 23px;
    background-color: #ff813a;
    color: white;
  }

  @media (max-width: 590px) {
    justify-content: start;
    font-size: 18px;
  }
`;

export const EmptyImages = styled.div`
  width: 290px;
  height: 290px;
  outline: none;
  background-color: #f9f9f9;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SingleImageWrapper = styled.div`
  position: relative;
`;
export const CancelSingleImageButton = styled.div`
  position: absolute;
  top: 3px;
  right: 3px;
  cursor: pointer;
`;
export const SingleImage = styled.img`
  width: 290px;
  height: 290px;
  outline: none;
  background-color: #f9f9f9;
  object-fit: contain;
`;
export const DragElement = styled.span`
  width: 290px;
  height: 290px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  color: #acacac;
  background-color: #f9f9f9;
  border: 2px dashed #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s;
  font-style: italic;
  cursor: pointer;
  input[type="file"] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
  }
`;

export const DragInputElement = styled.input``;

export const DragText = styled.div``;
export const DragClick = styled.div`
  position: absolute;
  z-index: 999;
  top: 69%;
  right: 0;
  left: 0;
  bottom: 0;
  color: blue;
  cursor: pointer;
`;

export const RightCheckBar = styled.div`
  background-color: #ff8038;
  border-radius: 10px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const InheritTextInputField = styled(TextInputField)`
  width: 180px;
  margin: 0px;
`;

export const RankWrapper = styled.div`
  padding-left: 10px;
  @media (max-width: 590px) {
    margin-bottom: 15px;
  }
`;

export const RankInputField = styled(TextInputField)`
  width: 160px;
  padding: 7px;
`;

export const SecondLanguageInputField = styled(TextInputField)`
  margin-bottom: 15px;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 290px;
  height: 290px;
  overflow-y: scroll;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const SmallImageWrapper = styled.div`
  margin-left: 10px;
  margin-top: 10px;
`;

export const CombineWrapper = styled.div`
  display: flex;

  @media (max-width: 590px) {
    flex-direction: column;
    align-items: start;
    justify-content: start;
  }
`;

export const PromotionTagWrapper = styled.div`
  padding-left: 0.8rem;
  width: 100%;
`;
